<template>
  <div
    class="breadcrumb pb-55 pt-21"
    :class="{
      white: map || singleview || header_banner,
      'brand-inner': singleview || header_banner
    }"
  >
    <div class="breadcrumb__inner container flex al-center">
      <router-link :to="get_main_page">
        <span class="f-13 bold">{{ $fn.tr("მთავარი") }} </span>
        <svg
          class="ml-10 mr-10"
          :class="{ 'mb-2': locale === 'ge' }"
          xmlns="http://www.w3.org/2000/svg"
          width="6.286"
          height="8"
          viewBox="0 0 6.286 8"
        >
          <path
            id="Icon_material-play-arrow"
            data-name="Icon material-play-arrow"
            d="M18.286,7.5v8L12,11.5Z"
            transform="translate(18.286 15.5) rotate(180)"
            fill="#1a1a1a"
          />
        </svg>
      </router-link>
      <router-link
        :to="link.full_url"
        v-for="(link, index) in get_menu"
        :key="index"
      >
        <span class="f-13 bold">
          {{
            $route.name == "PageViewRouter_ge"
              ? link.titles.ge.title
              : link.titles.en.title
          }}
        </span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="6.286"
          height="8"
          viewBox="0 0 6.286 8"
          class="ml-10 mr-10"
          :class="{ 'mb-2': locale === 'ge' }"
          v-if="index !== get_menu.length - 1"
        >
          <path
            id="Icon_material-play-arrow"
            data-name="Icon material-play-arrow"
            d="M18.286,7.5v8L12,11.5Z"
            transform="translate(18.286 15.5) rotate(180)"
            fill="#1a1a1a"
          />
        </svg>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    header_banner: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    console.log(this.$store.state.main.locale);
  },
  computed: {
    get_menu() {
      let menu = this.$store.state.main.indx.menus;
      let curr_menu = this.$store.state.main.selected_menu;
      menu = menu.filter(
        m =>
          (m.configs.includes("breadcrumb") &&
            m.set_home !== 1 &&
            m.id == curr_menu.id) ||
          (m.configs.includes("breadcrumb") &&
            m.set_home !== 1 &&
            m.id == curr_menu.pid)
      );
      return menu;
    },

    get_main_page() {
      let menu = this.$store.state.main.indx.menus;
      menu = menu.filter(m => m.set_home == 1);
      return menu[0].full_url;
    },
    locale() {
      return this.$store.state.main.locale;
    },
    map() {
      return this.$store.state.main.selected_menu.configs.includes("map");
    },
    singleview() {
      return this.$route.path.includes("singleview");
    }
    // header_banner(){
    //   if(this.$store.state.main.selected_menu.configs.includes('offers')){
    //     return true;
    //   }

    // }
  }
};
</script>

<style lang="scss" scoped>
.breadcrumb {
  a {
    color: $black;
    transition: 0.4s;
    @include hover {
      color: $red;
    }
  }
  svg path {
    transition: 0.4s;
  }
  &.white {
    a {
      color: white;
      @include hover {
        color: $blue;
      }
    }
    svg path {
      fill: white;
    }
  }
  &.brand-inner {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 21;
  }
  @media (max-width: 767px) {
    padding-bottom: 31px;
  }
}
.vacancy-inner {
  .breadcrumb.brand-inner {
    width: initial;
    position: relative;
    top: initial;
    left: initial;
    z-index: initial;
    a {
      color: $black;
      transition: 0.4s;
      @include hover {
        color: $red;
      }
    }
    svg path {
      transition: 0.4s;
      fill: $black;
    }
  }
}
.contact-container-dropdown {
  .breadcrumb.white {
    width: initial;
    position: relative;
    top: initial;
    left: initial;
    z-index: initial;
    a {
      color: $black;
      transition: 0.4s;
      @include hover {
        color: $red;
      }
    }
    svg path {
      transition: 0.4s;
      fill: $black;
    }
  }
}
</style>
